document.addEventListener('DOMContentLoaded', function() {
  // aboutページでのみ実行
  if (window.location.pathname === '/pages/about') {
    initSmoothScroll();
  }
});

function initSmoothScroll() {
  // アンカーリンクを取得
  const anchorLinks = document.querySelectorAll('a[href*="/pages/about#"]');
  
  anchorLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      const href = this.getAttribute('href');
      const targetId = href.split('#')[1];
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        // スムーズスクロール
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        
        // ドロワーメニューを閉じる
        closeDrawers();
      }
    });
  });
}



function closeDrawers() {
  // モバイルドロワーを閉じる
  const mobileDrawer = document.getElementById('Drawer-MobileNav');
  if (mobileDrawer && mobileDrawer.closeDrawer) {
    mobileDrawer.closeDrawer();
  }
  
  // PCドロワーを閉じる
  const pcDrawer = document.getElementById('Drawer-PcNav');
  if (pcDrawer && pcDrawer.closeDrawer) {
    pcDrawer.closeDrawer();
  }
  
  // その他のドロワーコンポーネントを閉じる
  const allDrawers = document.querySelectorAll('drawer-component');
  allDrawers.forEach(drawer => {
    if (drawer && drawer.closeDrawer) {
      drawer.closeDrawer();
    }
  });
  
  // モバイルメニューの開閉状態をリセット
  const mobileNavItems = document.querySelectorAll('.f-mobile-nav__item--has-child collapsible-tab');
  mobileNavItems.forEach(item => {
    if (item && item.close) {
      item.close();
    }
  });
  
  // ヘッダーのナビゲーションメニューを閉じる
  const headerNavItems = document.querySelectorAll('.f-site-nav__item--has-child details');
  headerNavItems.forEach(detail => {
    if (detail && detail.removeAttribute) {
      detail.removeAttribute('open');
    }
  });
} 